---
title: bookmarks
description: A simple way to save links.
linkUrl: https://github.com/matthewlyle/bookmarks
linkLabel: View on GitHub
linkIcon: github
---


I just wanted a simple way to save links. I didn't want a Reader mode, the ability to sync with Kindle, any Discover content, Social sharing, etc etc

**I just wanted to save some links**, so I ended up building a way to do that. You can see my personal implementation at https://bookmarks-dusky.vercel.app/ and fork your own on [Github](https://github.com/matthewlyle/bookmarks).

## The app 

![Bookmarks app screenshot](/tools/bookmarks/original/bookmarks.png)

The bookmark app started with a front-end prototype built using my standard prototype generator [@matthewlyle/sandbox-new](tools/sandbox-new). I then switched to NextJS and added a Turso database and Auth.js authorization using Google OAuth. 

There's one page: a paginated bookmark list. It's searchable and filterable by category. That's it. I mostly use the app to see bookmarks I've saved and delete ones I'm done with, though I can also manually add a bookmark here too.

## The extension 

The extension is the primary way I save a bookmark, as the link I want to save is usually open in my web browser. The extension hits the bookmark API, saves it with optional tagging, and returns a success notification.

<div class="tenor-gif-embed" data-postid="3575245" data-share-method="host" data-aspect-ratio="1.42857" data-width="100%"><a href="https://tenor.com/view/thumbs-up-90s-kid-cool-good-gif-3575245">Thumbs Up Kid GIF</a>from <a href="https://tenor.com/search/thumbs+up-gifs">Thumbs Up GIFs</a></div> <script type="text/javascript" async src="https://tenor.com/embed.js"></script>